import { Dispatch } from 'redux'

import anchor from '../../../constants/anchor'
import { apiInstance } from '../../api/apiInstance'
import { RootState } from '../../store/rootReducer'
import { storeDispatchTypes } from '../../store/storeDispatchTypes'

const getAvitoProfiles =
    () =>
    async (dispatch: Dispatch, getState: () => RootState): Promise<void> => {
        const { userData } = getState()
        const config = {
            headers: {
                Authorization: `${anchor} ${localStorage.getItem('accessToken')}`,
            },
        }
        const params = {
            userId: userData.smsAuth.userId,
        }
        try {
            const {
                data: { status, data },
            } = await apiInstance.post('/sales/marketplaces/getAvitoProfiles', params, config)
            if (status === 'ok') {
                dispatch({
                    type: storeDispatchTypes.setAvitoProfiles,
                    value: data || [],
                })
            }
        } catch (e) {
            console.error('get avito profiles failed', e)
        }
    }

export default getAvitoProfiles
